<template>
  <div>
    <div v-if="savedLabels.length === 0" class="no-labels-message">
      No label present
    </div>
    <label-selector-pipeline
      :all-labels="allLabels"
      :popup="openPopup"
      :selected-contact-id="selectedContactId"
      :saved-labels="savedLabels"
      @add="addItem"
      @remove="removeItem"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LabelSelectorPipeline from 'dashboard/components/widgets/LabelSelectorPipeline.vue';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  components: { LabelSelectorPipeline },
  mixins: [alertMixin],
  props: {
    contactId: {
      type: [String, Number],
      required: true,
    },
    popup:{
      type: Boolean,
      default: false
    },
    selectedContactId: {
      type: Number,
      default: null,
    },
    initialLabels: {
      type: Array,
      default: null,
    },
  },
  data(){
    return{
      openPopup: false
    };
  },

  computed: {
    savedLabels() {
      const availableContactLabels = this.$store.getters[
        'contactLabels/getContactLabels'
      ](this.contactId);
      return this.allLabels.filter(({ title }) =>
        availableContactLabels.includes(title)
      );
    },

    ...mapGetters({
      labelUiFlags: 'contactLabels/getUIFlags',
      allLabels: 'labels/getLabels',
    }),
  },

  watch: {
    contactId(newContactId, prevContactId) {
      if (newContactId && newContactId !== prevContactId) {
        this.seedLabelsFromProps();
      }
    },
    initialLabels: {
      handler() {
        this.seedLabelsFromProps();
      },
      deep: true,
    },
    popup(val) {
      this.openPopup = val;
    },
  },

  mounted() {
    this.seedLabelsFromProps();
  },

  methods: {
    async onUpdateLabels(selectedLabels) {
      try {
        await this.$store.dispatch('contactLabels/update', {
          contactId: this.contactId,
          labels: selectedLabels,
        });
      } catch (error) {
        this.showAlert(this.$t('CONTACT_PANEL.LABELS.CONTACT.ERROR'));
      }
    },

    addItem(value) {
      const result = this.savedLabels.map(item => item.title);
      result.push(value.title);
      this.onUpdateLabels(result);
    },

    removeItem(value) {
      const result = this.savedLabels
        .map(label => label.title)
        .filter(label => label !== value);
      this.onUpdateLabels(result);
    },

    seedLabelsFromProps() {
      const { contactId } = this;
      if (!contactId) {
        return;
      }

      if (Array.isArray(this.initialLabels)) {
        if (!this.$store.getters['contactLabels/hasContactLabels'](contactId)) {
          this.$store.dispatch('contactLabels/setContactLabel', {
            id: contactId,
            data: this.initialLabels,
          });
        }
        return;
      }

      this.fetchLabels(contactId);
    },

    async fetchLabels(contactId) {
      if (!contactId) {
        return;
      }

      if (this.$store.getters['contactLabels/hasContactLabels'](contactId)) {
        return;
      }

      this.$store.dispatch('contactLabels/get', contactId);
    },
  },
};
</script>

<style scoped>
  .no-labels-message {
    color:#706969;
    font-size: 13px;
  }
</style>


